import React, { useRef } from 'react';
var VeltNotificationsPanelContentList = function (props) {
    var notifications = props.notifications, listItemTemplate = props.listItemTemplate, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-list", { ref: ref, notifications: notifications ? (typeof notifications === 'string' ? notifications : JSON.stringify(notifications)) : undefined, "list-item-template": listItemTemplate ? (typeof listItemTemplate === 'string' ? listItemTemplate : JSON.stringify(listItemTemplate)) : undefined }, children));
};
export default VeltNotificationsPanelContentList;
